var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyBg2B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 303L214 249L214 272Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 303L292 203L214 249Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 203L198 202L214 249Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 249L146 255L214 272Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 203L281 174L198 202Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 174L272 164L198 202Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 382L316 344L264 303Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 303L378 312L292 203Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 202L146 255L214 249Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 388L275 382L264 303Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 101L162 184L204 74Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 202L162 184L146 255Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 344L378 312L264 303Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 388L264 303L207 379Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 454L382 416L345 345Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 379L264 303L214 272Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 311L207 379L214 272Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 345L378 312L316 344Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 104L277 123L368 139Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 184L140 193L146 255Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 357L127 311L37 268Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 255L127 311L214 272Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 174L277 123L272 164Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 74L162 184L198 202Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 184L154 101L140 193Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 139L281 174L292 203Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 312L394 239L292 203Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 379L259 416L254 388Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 388L259 416L275 382Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 416L410 373L345 345Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 139L277 123L281 174Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 74L198 202L272 164Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 239L368 139L292 203Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 239L391 143L368 139Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 139L373 116L289 104Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 379L254 440L259 416Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 345L316 344L331 454Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 345L410 373L378 312Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 466L254 440L207 379Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 379L116 380L83 357Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 311L116 380L207 379Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 143L373 116L368 139Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 74L272 164L277 123Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 344L275 382L331 454Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 312L452 279L394 239Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 239L456 159L391 143Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 357L116 380L127 311Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 380L147 426L207 379Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 311L146 255L37 268Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 373L442 309L378 312Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 30L204 74L289 104Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 104L204 74L277 123Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 309L452 279L378 312Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 268L146 255L140 193Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 387L116 380L106 379Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 387L147 426L116 380Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 357L103 387L106 379Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 454L275 382L259 416Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 440L331 454L259 416Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 509L331 454L282 539Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 101L76 155L140 193Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 459L218 466L207 379Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 116L305 53L289 104Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 502L175 459L147 426Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 426L175 459L207 379Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 331L473 261L452 279Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 279L473 261L394 239Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 143L393 56L373 116Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 331L452 279L442 309Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 74L139 76L154 101Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 101L80 108L76 155Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0L139 76L204 74Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 204L37 268L140 193Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 261L456 159L394 239Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 116L393 56L305 53Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 53L256 30L289 104Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 76L80 108L154 101Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 155L29 204L140 193Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 108L46 159L76 155Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 159L29 204L76 155Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 433L472 363L410 373Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 373L472 363L442 309Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 433L410 373L382 416Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 106L393 56L391 143Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 53L282 0L256 30Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 498L432 433L382 416Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 395L493 331L472 363Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 363L493 331L442 309Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 159L483 145L456 159Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 76L80 79L80 108Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 108L0 125L46 159Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 0L80 79L139 76Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 159L456 159L473 261Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 159L483 106L391 143Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 231L0 261L37 268Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 268L0 377L83 357Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 357L0 405L103 387Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 231L37 268L29 204Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 231L29 204L0 193Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 193L29 204L46 159Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 509L365 498L331 454Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 454L365 498L382 416Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 520L254 440L218 466Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 541L222 520L175 459Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 459L222 520L218 466Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 0L282 0L305 53Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 30L210 0L204 74Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 539L331 454L254 440Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 0L210 0L256 30Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 125L0 193L46 159Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 203L500 159L473 261Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 106L408 32L393 56Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 0L208 0L204 74Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 433L492 395L472 363Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 217L535 203L473 261Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 487L492 395L432 433Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 509L362 512L365 498Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 498L469 487L432 433Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 600L362 512L343 509Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 56L382 0L305 53Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 106L456 159L483 145Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 159L483 106L483 145Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 520L282 539L254 440Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 261L0 377L37 268Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 387L93 502L147 426Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 314L473 261L493 331Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 115L516 42L483 106Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0L132 0L139 76Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 99L0 125L80 108Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 99L80 108L80 79Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 0L382 0L408 32Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 32L382 0L393 56Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 505L93 502L103 387Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 520L276 600L282 539Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 502L175 541L175 459Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 377L0 405L83 357Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 395L546 314L493 331Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 465L80 505L103 387Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 502L157 571L175 541Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 31L0 99L80 79Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 314L563 217L473 261Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 203L582 115L500 159Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 542L469 487L365 498Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 391L600 340L546 314Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 542L365 498L362 512Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 0L435 0L408 32Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 0L408 32L483 106Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 541L276 600L222 520Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 600L157 571L93 502Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 0L23 31L80 79Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 42L454 0L483 106Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 405L0 465L103 387Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 600L162 600L157 571Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 487L531 450L492 395Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 314L600 231L563 217Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 115L483 106L500 159Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 600L276 600L175 541Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 539L381 600L343 509Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 600L447 542L362 512Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 487L530 495L531 450Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 600L282 600L282 539Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 465L13 503L80 505Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 340L600 231L546 314Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 140L582 115L535 203Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 0L19 0L23 31Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 31L0 0L0 99Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 571L162 600L175 541Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 600L93 502L80 505Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 42L494 0L454 0Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 391L546 314L492 395Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 140L535 203L563 217Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 42L600 0L494 0Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 505L530 495L469 487Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 450L600 391L492 395Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 600L381 600L282 539Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 542L531 505L469 487Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 231L600 140L563 217Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0L0 0L23 31Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 445L600 391L531 450Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 600L531 505L447 542Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 454L600 445L531 450Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 600L452 583L447 542Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 600L85 600L80 505Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 557L74 600L80 505Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 140L600 84L582 115Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 115L600 84L516 42Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 600L445 600L452 583Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 583L470 600L447 542Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 454L530 495L600 496Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 454L531 450L530 495Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 465L0 557L13 503Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 503L0 557L80 505Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 84L600 68L516 42Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 496L530 495L531 505Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 600L470 600L452 583Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 600L600 496L531 505Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 557L0 600L74 600Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 68L600 0L516 42Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 600L578 600L531 505Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 600L600 600L600 496Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBg2B);
export default __webpack_public_path__ + "static/media/polyBG2_b.64e1abbf6de71bd279a070c72c423a7a.svg";
export { ForwardRef as ReactComponent };